import { apiClient } from "../../base/ApiClient";

export const getUserById = async (name) => {
  const response = await apiClient.get(`/users/candidate/filter/${name}/`);
  return response.data;
};

export const createDomCare = async (domCareData) => {
  const response = await apiClient.post(`/client/domcare/`, domCareData);
  return response.data;
};

export const getDomCare = async (clientId) => {
  const response = await apiClient.get('/client/domcare/', {
    params: {
      client_id: clientId,
    },
  });
  return response.data;
};

export const deleteDomCare = async (id) => {
  const response = await apiClient.delete(`/client/domcare/${id}/`);
  return response.data;
};

export const getDomCareById = async (id) => {
  const response = await apiClient.get(`/client/domcare/${id}/`);
  return response.data;
};

export const updateDomCare = async (id, editData) => {
  const response = await apiClient.put(`/client/domcare/${id}/`,editData);
  return response.data;
};